import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import IMAGES from '../images';
import './Home.css';

// ── Intro Band ───────────────────────────────────────────────
function IntroBand() {
  return (
    <div className="intro-band">
      <p>
        Robinetterie &amp; Accessoires De Salle De Bain{' '}
        <span className="intro-band__gold">— Artisanat Tunisien</span>
        <br />
        Laiton Massif · Marbre · Acier Époxy
      </p>
    </div>
  );
}

// ── Brand Split (Notre Histoire) ─────────────────────────────
function BrandSplit() {
  return (
    <section className="brand-split">
      <div className="brand-split__img">
        <img src={IMAGES.logo} alt="Khansa Yazidi Logo" className="brand-split__logo-big" />
      </div>
      <div className="brand-split__content">
        <span className="section-label">Notre Histoire</span>
        <div className="brand-split__header">
          <h2 className="brand-split__title">
            Khansa Yazidi,<br />Le Brand
          </h2>
        </div>
        <div className="brand-split__divider" />
        <p className="brand-split__text">
          Fondée en 2017, Khansa Yazidi est une marque artisanale tunisienne de robinetterie
          et d'accessoires de salle de bain alliant plusieurs matériaux tel que le laiton massif,
          le marbre, la céramique et l'acier Epoxy.
        </p>
        <p className="brand-split__text">
          L'ensemble des créations sont entièrement façonnées à la main épousant des formes
          épurées et minimalistes.
        </p>
        <p className="brand-split__quote">
          « Une réinterprétation de l'espace Salle de bain ! »
        </p>
      </div>
    </section>
  );
}

// ── Designer Split (Le Designer) ─────────────────────────────
function DesignerSplit() {
  return (
    <section className="designer-split">
      <div className="designer-split__content">
        <span className="section-label">Le Designer</span>
        <h2 className="designer-split__title">
          Khansa Yazidi,<br />le Designer
        </h2>
        <div className="designer-split__divider" />
        <p className="designer-split__text">
          Architecte d'intérieur, Khansa Yazidi a fait ses études supérieures à l'École
          Supérieure des Sciences et Technologies du Design de Tunis, clôturant son cursus
          par un master de recherche en design espace en Juin 2016.
        </p>
        <p className="designer-split__text">
          Elle lance sa marque de robinetterie et d'accessoires de salle de bain artisanaux
          à 25 ans, après avoir fait ses preuves à Marrakech en tant qu'architecte d'intérieur.
        </p>
        <Link to="/contact" className="btn-outline-dark" style={{ marginTop: '1.5rem', display: 'inline-block' }}>
          En Savoir Plus
        </Link>
      </div>
      <div className="designer-split__img">
        <img src={IMAGES.designer} alt="Khansa Yazidi Designer" />
      </div>
    </section>
  );
}

// ── Video Section (Reusable Component) ────────────────────────
function VideoSection({ videoUrl, title, subtitle }) {
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) videoRef.current.pause();
      else videoRef.current.play();
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <section className="video-section">
      <div className="video-section__wrap">
        <video
          ref={videoRef}
          src={videoUrl}
          autoPlay
          muted
          loop
          playsInline
          className="video-section__video"
        />
        <div className="video-section__overlay" />
        <div className="video-section__content">
          <h2 className="video-section__title" style={{ color: '#fff' }}>{title}</h2>
          {subtitle && <p className="video-section__subtitle">{subtitle}</p>}
        </div>
        <button className="video-section__toggle" onClick={togglePlay}>
          {isPlaying ? 'Mettre en pause' : 'Lecture'}
        </button>
      </div>
    </section>
  );
}

// ── Video Selection (Same as VideoSection but with "Demander un Devis" button under Subtitle) ──
function VideoSelection({ videoUrl, title, subtitle }) {
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) videoRef.current.pause();
      else videoRef.current.play();
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <section className="video-section">
      <div className="video-section__wrap">
        <video
          ref={videoRef}
          src={videoUrl}
          autoPlay
          muted
          loop
          playsInline
          className="video-section__video"
        />
        <div className="video-section__overlay" />
        <div className="video-section__content">
          <h2 className="video-section__title" style={{ color: '#fff' }}>{title}</h2>
          {subtitle && <p className="video-section__subtitle" style={{ marginBottom: '2rem' }}>{subtitle}</p>}
          <Link to="/contact" className="video-section__btn">
            Demander un Devis
          </Link>
        </div>
        <button className="video-section__toggle" onClick={togglePlay}>
          {isPlaying ? 'Mettre en pause' : 'Lecture'}
        </button>
      </div>
    </section>
  );
}

// ── Garantie (Certificat) ────────────────────────────────────
function Certificat() {
  return (
    <section className="certificat">
      <div className="certificat__inner">
        <span className="section-label">Garantie d'Authenticité</span>
        <h2 className="certificat__title">Certificat d'authenticité</h2>
        <div className="certificat__divider" />
        <p className="certificat__text" style={{ color: '#555' }}>
          Chaque pièce Khansa Yazidi est accompagnée d'un certificat d'authenticité,
          garantissant son origine artisanale et la qualité irréprochable des matériaux utilisés.
          Une promesse de savoir-faire tunisien transmis de génération en génération.
        </p>
        <Link to="/garantie" className="btn-outline-white">En savoir plus</Link>
      </div>
    </section>
  );
}

// ── Standalone Elegant Devis Button Section ──────────────────
function DevisCTA() {
  return (
    <section className="devis-cta">
      <div className="devis-cta__content">
        <span className="section-label">Votre Espace</span>
        <h2 className="devis-cta__title">Sublimez Votre Intérieur</h2>
        <p className="devis-cta__text">
          Chaque création Khansa Yazidi est une œuvre d'art unique façonnée sur mesure dans nos ateliers.
          Laiton massif, marbre de Carrare et savoir-faire ancestral d'exception.
        </p>
        <Link to="/contact" className="devis-cta__btn">
          Demander un Devis
        </Link>
      </div>
    </section>
  );
}

// ── Presse Quotes ────────────────────────────────────────────
const PRESS = [
  {
    pub: 'Design Magazine',
    quote: 'Des créations qui allient avec grâce tradition artisanale et modernité épurée, signant un style résolument tunisien.',
  },
  {
    pub: 'Art & Décoration',
    quote: "Khansa Yazidi réinvente l'espace salle de bain avec une élégance rare et une sophistication intemporelle.",
  },
  {
    pub: 'Maison & Objet Paris',
    quote: "Le laiton martelé à la main, une signature qui s'impose avec brio dans le paysage du design méditerranéen.",
  },
];

function Presse() {
  return (
    <section className="presse">
      <div className="section-header">
        <span className="section-label">Ils parlent de nous</span>
        <h2 className="section-title">Presse</h2>
        <div className="section-divider" />
      </div>
      <div className="presse__grid">
        {PRESS.map((item) => (
          <div key={item.pub} className="presse__card">
            <div className="presse__pub">{item.pub}</div>
            <blockquote className="presse__quote">"{item.quote}"</blockquote>
          </div>
        ))}
      </div>
    </section>
  );
}

// ── HOME PAGE ────────────────────────────────────────────────
export default function Home() {
  return (
    <main>
      {/* 1. Slider */} { /* TODO : Button Demander un devis au dessus de subtitle dans le video */}
      <VideoSelection 
        videoUrl="https://khansayazidi.tn/assets/khansa-reel-02-1.mp4" 
        title="Khansa Yazidi" 
        subtitle="Robinetterie et accessoires de salle de bain artisanaux" 
      />

      <Hero />
      {/* <IntroBand />*/ }

      {/* 1.5 CTA DEVIS ENCORE       <DevisCTA />*/}
 

      {/* 2. Video 1 */}
      <VideoSection 
        videoUrl="https://khansayazidi.tn/assets/khansa-22-mars-01-2.mp4"
        title="L'Art du Laiton" 
        subtitle="Découvrez notre savoir-faire artisanal" 
      />

      {/* 3. History Brand */}
      <BrandSplit /> { /* TODO : Remplacer le photo par le logo cuivre */}

      {/* 4. Video 2 
      <VideoSection 
        videoUrl="https://khansayazidi.tn/assets/khansa reel 02.1.mp4" 
        title="La Matière Brute" 
        subtitle="Entièrement façonné à la main" 
      />
      */}

      {/* 5. History Designer */}
      <DesignerSplit /> { /* TODO : Taswiret Khansa lezem tkoun kemla fel version mobile */}

      {/* 6. Video 3 */}
      <VideoSection 
        videoUrl="https://khansayazidi.tn/assets/img-4783.mp4" 
        title="Olea Aurea" 
        subtitle="L'essence du raffinement Intemporels" 
      />

      {/* 7. Garantie : Cachée pour le moment */}
        {/* <Certificat /> */}

      {/* 7.5 Demander un devis (Elegant gold centered CTA button) <DevisCTA /> */}
      <VideoSelection 
        videoUrl={IMAGES.video} 
        title="Déesse" 
        subtitle="Là où le ciel rencontre la terre, où le ciel danse avec l'eau ..." 
      />

      {/* 8. Press */}
      <Presse />
    </main>
  );
}
